import { handleActions } from "redux-actions";

import {
    clearUsers,
    createUser,
    createUserError,
    createUserSuccess,
    getUserByID,
    getUsers,
    getUsersByIDError,
    getUsersByIDSuccess,
    getUsersError,
    getUsersSuccess
} from "./actions";


const initialState = {
    isLoading: false,
    count: 0,
    users: [],
    isLoadingUser: false,
    userById: null
};

export const usersEntriesReducer = handleActions(
    {
        [clearUsers]: () => ({ ...initialState }),

        [getUsers]: (state) => ({
            ...state,
            users: [],
            isLoading: true
        }),
        [getUsersSuccess]: (state, { payload }) => ({
            ...state,
            ...payload,
            isLoading: false
        }),
        [getUsersError]: (state) => ({
            ...state,
            isLoading: false
        }),

        [getUserByID]: (state) => ({
            ...state,
            isLoadingUser: true
        }),
        [getUsersByIDSuccess]: (state, { payload }) => ({
            ...state,
            userById: payload,
            isLoadingUser: false
        }),
        [getUsersByIDError]: (state) => ({
            ...state,
            isLoadingUser: false
        }),

        [createUser]: (state) => ({
            ...state,
            isLoadingUser: true
        }),
        [createUserSuccess]: (state) => ({
            ...state,
            isLoadingUser: false
        }),
        [createUserError]: (state) => ({
            ...state,
            isLoadingUser: false
        })
    },
    initialState
);
